<template>
  <div class="preview-survey" id="survey-scroller">
    <template v-if="!error && page">
      <section class="section">
        <div class="columns page-wrap is-centered is-vcentered" v-if="page">
          <transition :key="question.qid" mode="out-in" name="page-component" v-for="question in questions">
            <component
                :is="`Q${question.type}`"
                :lang="lang"
                :question="question"
                :show-question-code="showQuestionCode"
                :show-answer-code="showAnswerCode"
                :value="changes"
                @input="onChange"
            ></component>
          </transition>
        </div>
      </section>
    </template>
    <ErrorMessage :error="error"></ErrorMessage>
  </div>
</template>

<script>
import _ from 'lodash'

import { getSurveyTemplatePage } from '@/api/response'
import { QuestionTypeComponentsMixin } from '@/mixins/question-type-components'
import { checkConditions } from '@/utils/question'
import { ErrorHandlerMixin } from '@/mixins/error-handler'
import { LocaleSwitchingMixin } from '@/mixins/locale-switching'
import { TemplateMixin } from '@/mixins/template'

export default {
  name: 'PreviewTemplatePage',
  mixins: [
    QuestionTypeComponentsMixin,
    ErrorHandlerMixin,
    LocaleSwitchingMixin,
    TemplateMixin,
  ],
  data () {
    return {
      page: null,
    }
  },
  computed: {
    questions () {
        const self = this

        const questions = self.page?.questions
            .filter((question) => {
                return checkConditions(question?.conditions, self.changes)
            })

        _.forEach(questions, function(value) {
            if (value?.sub_questions.length > 0) {
              value.sub_questions = value.sub_questions.filter((subQuestion) => {
                return checkConditions(subQuestion.conditions, self.changes)
              })
            }

          if (value?.answers.length > 0) {
            value.answers = value.answers.filter((answerQuestion) => {
              return checkConditions(answerQuestion.conditions, self.changes)
            })
          }
        });

        return questions
    }
  },
  methods: {
    async init () {
      this.error = null
      const loadingComponent = this.$buefy.loading.open()
      try {
        const { params: { code, pageCode } } = this.$route
        if (code && pageCode) {
          await this.getSurveyTemplate()
          const { data: { data: page } } = await getSurveyTemplatePage(code, pageCode)
          this.page = page
        }
      } catch (error) {
        this.errorHandler(error)
      } finally {
        loadingComponent.close()
      }
    },
  },
  created () {
    this.init()
  }
}
</script>
